import { render, staticRenderFns } from "./LegCardShell.vue?vue&type=template&id=a4444c02"
import script from "./LegCardShell.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegCardShell.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports